import React from 'react';
import { FlightContext } from '.';

export const useFlightProvider = () => {
  const { 
    status,
    battery, 
    flightData,
    flightMode, 
    velocityNed, 
    attitudeEuler, 
    distanceSensor, 
    gpsInfo,
    vhrNud,
  } = React.useContext(FlightContext);

  return {
    status,
    battery,
    flightMode,
    velocityNed,
    attitudeEuler,
    distanceSensor,
    gpsInfo,
    vhrNud,
    flightData,
  };
};